import React, { useCallback, useState } from 'react';

import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';

import { trackEvent } from 'src/lib/analytics';
import { getQueryParams } from 'src/lib/history';
import { localStorage } from 'src/lib/localStorage';

const ensureKey = (key, label) => {
  if (!key || key.length === 0) {
    return label.toLowerCase().replaceAll(' ', '_');
  } else return key;
};
const TabsContainer = ({ rememberTabKey, tabs, analyticsEvent, ...props }) => {
  let [selected, setSelected] = useState(undefined);
  if (selected === undefined && rememberTabKey) {
    let openKey = localStorage.getItem(rememberTabKey) || getQueryParams().tab_key;
    let index = tabs.findIndex(t => ensureKey(t.key, t.label) === openKey);
    if (index === -1) index = 0;
    selected = index;
  }

  if (selected === undefined) selected = 0;

  const onSelect = useCallback((index) => {
    setSelected(index);
    const selectedKey = ensureKey(tabs[index].key, tabs[index].label);
    if (rememberTabKey) localStorage.setItem(rememberTabKey, selectedKey);
    if (analyticsEvent) {
      trackEvent(analyticsEvent, { label: selectedKey });
    }
  }, [tabs, rememberTabKey, analyticsEvent]);

  const { tabList, tabContent } = tabs.reduce((acc, { key, label, content }) => {
    key = ensureKey(key, label);
    acc.tabList.push(<Tab key={key}>{label}</Tab>);
    acc.tabContent.push(<TabPanel key={key}>{content}</TabPanel>);

    return acc;
  }, { tabList: [], tabContent: [] });

  return (
    <Tabs
      id="main-navigation"
      selected={selected}
      onChange={onSelect}
      shouldUnmountTabPanelOnChange
      {...props}
    >
      <TabList>
        {tabList}
      </TabList>

      {tabContent}
    </Tabs>
  );
};

export default TabsContainer;
